import { useQuery } from '@tanstack/react-query';
import { fetchChecklistTemplates } from '@apis/checklists';
import { checklistTemplatesKey } from '@constants/queryKeys';
import type { SiteId } from '@interfaces/IScheduler';

/** The templates the Edit tab's picker offers. They change rarely, so one
 *  fetch per session is plenty. */
export function useChecklistTemplates(siteId: SiteId) {
  return useQuery({
    queryKey: checklistTemplatesKey(siteId),
    queryFn: ({ signal }) => fetchChecklistTemplates(siteId, signal),
    staleTime: 30 * 60_000,
  });
}
